import { render, staticRenderFns } from "./contractCreateFeeAdd.vue?vue&type=template&id=8755b87c"
import script from "./contractCreateFeeAdd.vue?vue&type=script&lang=js"
export * from "./contractCreateFeeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports